import { Schedule, ScheduleDetail, ScheduleSendable } from '@/entities/analytics-schedule';
import { intoSendableRule } from '@/services/api/resources/rrule';
import { filterListToEditableGroups, filterListToEditableUsers } from '@/ui/helpers';

export function intoEditable(data: ScheduleDetail): Schedule {
  return {
    ...data.data,
    assignees: data.data.assignees.map(user => `user_${user.id}`),
    assignedGroups: data.data.assignedGroups.map(group => `group_${group.id}`),
  };
}

export function intoSendable(data: Schedule): ScheduleSendable {
  const {
    assignees,
    assignedGroups,
    rule,
  } = data;

  return {
    rule: intoSendableRule(rule),
    assignees: {
      users: filterListToEditableUsers(assignees),
      groups: filterListToEditableGroups(assignedGroups),
    },
  };
}
